import { c as _c } from "react-compiler-runtime";
import { useCallback } from 'react';
import useIsScreenWidthBelowThreshold from './useIsScreenWidthBelowThreshold';
import { IS_OPEN } from '../constants/CollaborationSidebarStateProperties';
export default function useSidebarOpenCloseHandlers(t0) {
  "use memo";

  const $ = _c(14);
  const {
    onUpdateCollaborationSidebarState,
    openLeftEditor,
    closeLeftEditor
  } = t0;
  const isScreenWidthBelowThreshold = useIsScreenWidthBelowThreshold();
  let t1;
  if ($[0] !== closeLeftEditor || $[1] !== isScreenWidthBelowThreshold) {
    t1 = () => {
      if (closeLeftEditor && isScreenWidthBelowThreshold) {
        closeLeftEditor();
      }
    };
    $[0] = closeLeftEditor;
    $[1] = isScreenWidthBelowThreshold;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const maybeCloseLeftEditor = t1;
  let t2;
  if ($[3] !== maybeCloseLeftEditor || $[4] !== onUpdateCollaborationSidebarState) {
    t2 = () => {
      onUpdateCollaborationSidebarState({
        [IS_OPEN]: true
      });
      maybeCloseLeftEditor();
    };
    $[3] = maybeCloseLeftEditor;
    $[4] = onUpdateCollaborationSidebarState;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onOpenSidebar = t2;
  let t3;
  if ($[6] !== isScreenWidthBelowThreshold || $[7] !== onUpdateCollaborationSidebarState || $[8] !== openLeftEditor) {
    t3 = () => {
      onUpdateCollaborationSidebarState({
        [IS_OPEN]: false
      });
      if (openLeftEditor && isScreenWidthBelowThreshold) {
        openLeftEditor();
      }
    };
    $[6] = isScreenWidthBelowThreshold;
    $[7] = onUpdateCollaborationSidebarState;
    $[8] = openLeftEditor;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const handleClose = t3;
  let t4;
  if ($[10] !== handleClose || $[11] !== maybeCloseLeftEditor || $[12] !== onOpenSidebar) {
    t4 = {
      handleClose,
      onOpenSidebar,
      maybeCloseLeftEditor
    };
    $[10] = handleClose;
    $[11] = maybeCloseLeftEditor;
    $[12] = onOpenSidebar;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}